import { CHANGE_DATE } from '../actions/actionTypes';

const today = new Date();
const dates = [17, 18, 19, 20];

let date = 17;

for (let i = 0; i < dates.length; i++) {
  if (today === new Date(`October ${dates[i]}, 2016`)) {
    date = dates[i];
  }
}

function dateSelector(state = date, action) {
  switch (action.type) {
    case CHANGE_DATE:
      return action.newDate;
    default:
      return state;
  }
}

export default dateSelector;



/** WEBPACK FOOTER **
 ** ./src/reducers/dateSelector.js
 **/